import { Views } from '@neos/app'
import { OpenModeType, PopupPosition } from '@neos/shared'

export const views: Views = {
  default: [
    {
      name: 'HomePageUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/HomePageUI/HomePageUI.vue'),
    },
    {
      name: 'InvoiceOrderDocumentCategoryUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/InvoiceOrderDocumentCategoryUI/InvoiceOrderDocumentCategoryUI.vue'),
    },
    {
      name: 'InvoiceOrderDocumentUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/InvoiceOrderDocumentUI/InvoiceOrderDocumentUI.vue'),
    },
    {
      name: 'InvoiceOrderUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/InvoiceOrderUI/InvoiceOrderUI.vue'),
    },
    {
      name: 'InvoiceUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/InvoiceUI/InvoiceUI.vue'),
    },
    {
      name: 'OrderUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/OrderUI/OrderUI.vue'),
    },
  ],
}
